export default async ({ store }) => {
  const { cognitoUser } = store.state.auth;
  await store.dispatch('userAccount/getUserAccounts', {
    filter: {
      email: { eq: cognitoUser.attributes.email },
    },
  });
};
